<!--
 * @Author: YuanYuan
 * @Date: 2024-05-11 09:46:45
 * @LastEditTime: 2024-05-11 10:01:28
 * @Description: icon图标，悬浮显示提示语
-->
<template>
  <el-tooltip v-bind="$attrs" v-on="$listeners">
    <i :class="['color-gray-7', iconClazz]" :style="{transform: `translateY(${positionTop})`}" />
    <template v-for="item in slotKeys" :slot="item">
      <slot :name="item"></slot>
    </template>
  </el-tooltip>
</template>

<script setup>
import { toRefs, computed, getCurrentInstance } from 'vue'

const $vm = getCurrentInstance().proxy

const props = defineProps({
  iconClazz: {
    type: String,
    default: 'ws-icon-question-circle'
  },
  positionTop: {
    type: String,
    default: '1px'
  }
})

const { iconClazz, positionTop } = toRefs(props)

const slotKeys = computed(() => Object.keys($vm.$slots))
</script>